import { useDragAndDrop } from "@formkit/drag-and-drop/react";
import { Image } from "@mui/icons-material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import {
	Avatar,
	Box,
	Button,
	Grid,
	ListItem,
	ListItemAvatar,
	ListItemIcon,
	ListItemText,
	Paper,
} from "@mui/material";
import { useState } from "react";

export default function DragAndDropItems({ handleChange, items = [] }) {
	const [initialItems, setInitialItems] = useState(items);
	const [changed, setChanged] = useState(false);

	const [parentRef, values, setValues] = useDragAndDrop(initialItems, {
		group: "groups",
		itemKey: (item) => item.id,

		onSort: ({ parent, draggedNodes, targetNodes }) => {
			console.log("✅ Order changed!");
			console.log("Dragged nodes:", draggedNodes);
			console.log("New order:", parent.data); // parent.value = reordered array
			// const changed = parent.value.some(
			// 	(item, index) => item.id !== initialItems[index].id
			// );
			// console.log("Order changed?", changed);
		},
		onDragend: () => {
			console.log("Drag ended. Final order:", values);
			const changed = values.some(
				(item, index) => item.id !== initialItems[index].id
			);
			setChanged(changed);
			console.log("Order changed?", changed);
		},
	});
	const handleReset = () => {
		setValues(initialItems); // ✅ restore the original items
	};

	return (
		<Paper sx={{ p: 2 }}>
			<Grid ref={parentRef} container justifyContent={"center"}>
				{values.map((item) => (
					<Grid
						data-label={item.id}
						key={item.id}
						item
						xs={12}
						md={3}
						sx={{
							cursor: "grab",
							px: 1,
							pb: 2,
						}}
					>
						<ListItem
							sx={{
								cursor: "grab",
								bgcolor: "#f5f5f5",
								borderRadius: 1,
								gap: 2,
							}}
						>
							<ListItemAvatar
								sx={{
									width: 100,
									aspectRatio: "3/4",
									borderRadius: 3,
									overflow: "hidden",
								}}
							>
								<Avatar
									src={item.icon}
									variant="square"
									sx={{
										width: "100%",
										height: "100%",
										objectFit: "cover", // or "fill"
									}}
								>
									<Image sx={{ fontSize: 50 }} />
								</Avatar>
							</ListItemAvatar>

							<ListItemText
								primary={item.label}
								secondary={item.category}
							/>

							<ListItemIcon sx={{ minWidth: 36 }}>
								<DragIndicatorIcon />
							</ListItemIcon>
						</ListItem>
					</Grid>
				))}
			</Grid>
			<Box
				sx={{
					// minWidth: 200,
					display: changed ? "flex" : "none",
					justifySelf: "center",
					gap: 1,
				}}
			>
				<Button
					variant="contained"
					color="secondary"
					// fullWidth
					sx={
						{
							// minWidth: 200,
						}
					}
					onClick={handleReset}
				>
					Reset Order
				</Button>
				<Button
					variant="contained"
					color="primary"
					// fullWidth
					sx={
						{
							// minWidth: 200,
						}
					}
					onClick={() => {
						setInitialItems(values);
						setChanged(false);
						handleChange(values);
					}}
				>
					Change Order
				</Button>
			</Box>
		</Paper>
	);
}
